"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChildSeatType = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const getChildSeatType = (birthdayAt, departureAt, seatType) => {
    if (seatType) {
        switch (seatType) {
            case legacy_enums_1.PartnerApiChildSeat.RearFacing: {
                return legacy_enums_1.ChildSeatType.RearFacing;
            }
            case legacy_enums_1.PartnerApiChildSeat.ForwardFacing: {
                return legacy_enums_1.ChildSeatType.ForwardFacing;
            }
            case legacy_enums_1.PartnerApiChildSeat.BoosterSeat: {
                return legacy_enums_1.ChildSeatType.BoosterSeat;
            }
            case legacy_enums_1.PartnerApiChildSeat.Booster: {
                return legacy_enums_1.ChildSeatType.Booster;
            }
            default: {
                throw new Error("Incorrect child seats type");
            }
        }
    }
    let childSeatType;
    let childSeatBirthAtLimitTo = new Date(departureAt.getTime());
    const childSeatBirthAtLimitFrom = new Date(departureAt.getTime());
    legacy_enums_1.ChildSeatTypes.forEach((cy) => {
        childSeatBirthAtLimitTo = new Date(childSeatBirthAtLimitFrom.getTime());
        childSeatBirthAtLimitFrom.setUTCFullYear(childSeatBirthAtLimitTo.getUTCFullYear() - cy.yearsDifference);
        if (childSeatBirthAtLimitFrom.getTime() < birthdayAt.getTime() && childSeatBirthAtLimitTo.getTime() > birthdayAt.getTime()) {
            childSeatType = cy.childSeatType;
        }
    });
    // this fallback can happen when partner sends passenger of type Child that is over 12 years old
    return childSeatType ?? legacy_enums_1.ChildSeatType.Booster;
};
exports.getChildSeatType = getChildSeatType;
//# sourceMappingURL=getChildSeatType.js.map